var React = require('react');

function CheckInCircle (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_2102_4067)","key":0},[React.createElement("circle",{"cx":"16","cy":"16","r":"15.1","stroke":"#161616","strokeWidth":"1.8","key":0}),React.createElement("path",{"d":"M10.665 15.8146L14.5649 19.7147L22.2796 12","stroke":"currentColor","strokeWidth":"1.8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_2102_4067"},React.createElement("rect",{"width":"32","height":"32","fill":"white"})))]);
}

CheckInCircle.defaultProps = {"width":"100%","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 32 32","fill":"none"};

module.exports = CheckInCircle;

CheckInCircle.default = CheckInCircle;
